module.exports = __webpack_public_path__ + "img/loginImage.58696685.svg";